import styled from 'styled-components';
import { ButtonGroupMixin } from '../../mixins/components/ButtonGroupMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledButtonGroup = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['conjoined', 'direction', 'fluid'])
}).withConfig({
  displayName: "StyledButtonGroup",
  componentId: "c11n-8-107-0__sc-1v59d24-0"
})(["", ""], ButtonGroupMixin);